/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/named */
import { StopOutlined } from '@ant-design/icons';
import { Button, Card, Grid, message, Result, Space, Spin, Steps } from 'antd';
import React, { useEffect } from 'react';
import { useSiniestroContext } from '../../../../context/siniestro-context';
import { isMobile } from '../../../../utils';
import LandingPage from './Landing';
import { stepStyle } from './styles';
import Success from './Success';
import DocumentosVehiculos from './vehiculos/DocumentosVehiculos';
import FotografiasVehiculos from './vehiculos/FotografiasVehiculos';
import ResumenVehiculos from './vehiculos/ResumenVehiculos';

import DocumentosPatrimoniales from './patrimoniales/DocumentosPatrimoniales';
import FotografiasPatrimoniales from './patrimoniales/FotografiasPatrimoniales';
import ResumenPatrimoniales from './patrimoniales/ResumenPatrimoniales';

import DocumentosPersonales from './personales/DocumentosPersonales';
import ResumenPersonales from './personales/ResumenPersonales';

const { useBreakpoint } = Grid;
const { Step } = Steps;

function Stepper(props) {
  const {
    getSiniestro,
    uploadDocumentos,
    getImages,
    validateStep,
    updateSiniestro,
    comentario
  } = useSiniestroContext();
  const [step, setStep] = React.useState(
    props.props.location.pathname.includes('desktop') ? 2 : 0
  );
  const [start, setStart] = React.useState(true);
  const [reaundar, setReanudar] = React.useState(false);
  const [siniestro, setSiniestro] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [resultado, setResultado] = React.useState(false);

  const fetch = async () => {
    const result = await getSiniestro(props.props.match.params.token);
    getImages(result);
    setSiniestro(result);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const continueStep = async () => {
    setReanudar(true);
    setStep(1);
  };

  const next = async () => {
    setStep(step + 1);
  };

  const back = () => {
    setStep(step - 1);
  };

  const stepPagesPersonales = [
    <LandingPage setStart={setStart} />,
    <DocumentosPersonales next={next} back={back} />,
    <ResumenPersonales next={next} back={back} continueStep={continueStep} />
  ];

  const stepPagesPatrimoniales = [
    isMobile ? (
      <LandingPage setStart={setStart} />
    ) : (
      <Card>
        <Result
          icon={<StopOutlined />}
          title="Debe acceder desde un dispositivo móvil"
        />
      </Card>
    ),
    isMobile ? (
      <FotografiasPatrimoniales
        next={next}
        back={back}
        start={start}
        continue={reaundar}
      />
    ) : (
      <Card>
        <Result
          icon={<StopOutlined />}
          title="Debe acceder desde un dispositivo móvil"
        />
      </Card>
    ),
    <DocumentosPatrimoniales next={next} back={back} />,
    <ResumenPatrimoniales next={next} back={back} continueStep={continueStep} />
  ];

  const stepPagesVehiculos = [
    isMobile ? (
      <LandingPage setStart={setStart} />
    ) : (
      <Card>
        <Result
          icon={<StopOutlined />}
          title="Debe acceder desde un dispositivo móvil"
        />
      </Card>
    ),
    isMobile ? (
      <FotografiasVehiculos
        next={next}
        back={back}
        start={start}
        continue={reaundar}
      />
    ) : (
      <Card>
        <Result
          icon={<StopOutlined />}
          title="Debe acceder desde un dispositivo móvil"
        />
      </Card>
    ),
    <DocumentosVehiculos next={next} back={back} />,
    <ResumenVehiculos next={next} back={back} continueStep={continueStep} />
  ];

  const stepsVehiculos = [
    {
      title: 'Paso 1',
      description: (
        <span>
          Instrucciones de <strong>Inspección</strong>
        </span>
      )
    },
    {
      title: 'Paso 2',
      description: <span>Subí las fotos del Vehículo</span>
    },
    {
      title: 'Paso 3',
      description: <span>Subí los Documentos</span>
    },
    {
      title: 'Paso 4',
      description: (
        <span>
          Confirmar <strong>Fotos/Documentos</strong>
        </span>
      )
    }
  ];

  const stepsPersonales = [
    {
      title: 'Paso 1',
      description: (
        <span>
          Instrucciones de <strong>Inspección</strong>
        </span>
      )
    },
    {
      title: 'Paso 2',
      description: <span>Subí los Documentos</span>
    },
    {
      title: 'Paso 3',
      description: (
        <span>
          Confirmar <strong>Fotos/Documentos</strong>
        </span>
      )
    }
  ];

  const stepsPatrimoniales = [
    {
      title: 'Paso 1',
      description: (
        <span>
          Instrucciones de <strong>Inspección</strong>
        </span>
      )
    },
    {
      title: 'Paso 2',
      description: <span>Subí las fotos del Patrimonio</span>
    },
    {
      title: 'Paso 3',
      description: <span>Subí Documentos</span>
    },
    {
      title: 'Paso 4',
      description: (
        <span>
          Confirmar <strong>Documentos</strong>
        </span>
      )
    }
  ];

  const lastStepIndex = stepPagesVehiculos.length - 1;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onStepSubmit = React.useCallback(() => {
    if (step === 1) {
      message.error('Debe subir las fotos');
    } else {
      setStep(() =>
        Math.min(
          step + 1,
          siniestro.poliza.id_producto === 1 ||
            siniestro.poliza.id_producto === 7
            ? lastStepIndex
            : lastStepIndex - 1
        )
      );
    }
  });

  const subirDocumentos = async () => {
    if (validateStep(siniestro.poliza.id_producto)) {
      setLoading(true);
      await uploadDocumentos(siniestro);
      await updateSiniestro({
        comentario: comentario || siniestro.comentario,
        etapa: 'INICIADA'
      });
      setLoading(false);
      next();
    }
  };

  const Pasos = ({ current }) => {
    const screens = useBreakpoint();
    let stepProps;
    if (screens.md === false) {
      stepProps = { direction: 'vertical' };
    } else if (screens.md === true) {
      stepProps = { type: 'navigation' };
    }
    return (
      <>
        {(screens.md === true || screens.md === false) && (
          <Steps
            {...stepProps}
            size="small"
            current={current}
            style={stepStyle}
          >
            {(siniestro.poliza.id_producto === 1 ||
              siniestro.poliza.id_producto === 7) &&
              stepsVehiculos
                .slice(0, 6)
                .map((item) => (
                  <Step
                    key={item.title}
                    title={item.title}
                    description={item.description}
                  />
                ))}
            {(siniestro.poliza.id_producto === 2 ||
              siniestro.poliza.id_producto === 3) &&
              stepsPersonales
                .slice(0, 6)
                .map((item) => (
                  <Step
                    key={item.title}
                    title={item.title}
                    description={item.description}
                  />
                ))}
            {(siniestro.poliza.id_producto === 4 ||
              siniestro.poliza.id_producto === 5 ||
              siniestro.poliza.id_producto === 6) &&
              stepsPatrimoniales
                .slice(0, 6)
                .map((item) => (
                  <Step
                    key={item.title}
                    title={item.title}
                    description={item.description}
                  />
                ))}
          </Steps>
        )}
      </>
    );
  };

  const getButtons = () => {
    if (step === 0) {
      return (
        <Button onClick={onStepSubmit} type="primary">
          Iniciar
        </Button>
      );
    }

    if (
      (step === 2 &&
        siniestro.poliza.id_producto !== 2 &&
        siniestro.poliza.id_producto !== 3) ||
      (step === 1 &&
        (siniestro.poliza.id_producto === 2 ||
          siniestro.poliza.id_producto === 3))
    ) {
      return (
        <Space style={{ margin: '10px' }}>
          <Button
            onClick={() => {
              setStart(false);
              back();
            }}
          >
            Anterior
          </Button>
          <Button
            onClick={() => {
              uploadDocumentos(siniestro);
              updateSiniestro({
                comentario: comentario || siniestro.comentario,
                etapa: 'INICIADA'
              });
              setResultado(true);
            }}
          >
            Guardar flujo
          </Button>
          <Button
            type="primary"
            loading={loading}
            onClick={() => {
              subirDocumentos();
            }}
          >
            Siguiente
          </Button>
        </Space>
      );
    }
    return null;
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card>
      {siniestro &&
        (siniestro.etapa === 'FIRMADA' || siniestro.etapa === 'INICIADA') && (
          <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
            {!loading && (
              <>
                {step === 4 ||
                (step === 3 &&
                  (siniestro.poliza.id_producto === 2 ||
                    siniestro.poliza.id_producto === 3)) ? (
                  <Success siniestro={siniestro} />
                ) : (
                  <div>
                    <Pasos current={step} />
                    {!resultado && (
                      <div>
                        {(siniestro.poliza.id_producto === 1 ||
                          siniestro.poliza.id_producto === 7) &&
                          stepPagesVehiculos[step]}
                        {(siniestro.poliza.id_producto === 2 ||
                          siniestro.poliza.id_producto === 3) &&
                          stepPagesPersonales[step]}
                        {(siniestro.poliza.id_producto === 4 ||
                          siniestro.poliza.id_producto === 5 ||
                          siniestro.poliza.id_producto === 6) &&
                          stepPagesPatrimoniales[step]}
                        <div>
                          {(isMobile ||
                            siniestro.poliza.id_producto === 2 ||
                            siniestro.poliza.id_producto === 3 ||
                            step === 2) &&
                            getButtons()}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </Spin>
        )}
      {resultado && (
        <Result
          status="success"
          title="¡Proceso guardado con éxito!"
          subTitle={
            <>
              <p>Estimado/a Sr/Sra {siniestro.poliza.persona.nombres}</p>
              <p>
                Su inspección ha sido guardada exitosamente, para continuar
                puede dar click al mismo link recibido inicialmente.{' '}
                <a
                  href={`${window.location.origin}/siniestros/form/${siniestro.token}`}
                >
                  Continuar inspección{' '}
                </a>{' '}
              </p>
              <strong>¡Muchas gracias!</strong>
            </>
          }
          extra={
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Ir al inicio
            </Button>
          }
        />
      )}
      {siniestro && siniestro.etapa === 'FOTOS_SUBIDAS' && (
        <Result
          status="success"
          title="¡Subida de fotos/documentos finalizada!"
          extra={
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Ir al inicio
            </Button>
          }
        />
      )}
      {siniestro &&
        siniestro.etapa !== 'FOTOS_SUBIDAS' &&
        siniestro.etapa !== 'INICIADA' &&
        siniestro.etapa !== 'FIRMADA' && (
          <Result
            status="warning"
            title="¡Acción no permitida!"
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  window.location.href = `/siniestros`;
                }}
              >
                Volver al listado
              </Button>
            ]}
          />
        )}
    </Card>
  );
}

export default Stepper;
